import { GameService } from './../core/services/game.service';
import { Component, OnInit } from "@angular/core";

import { Location } from "@angular/common";

@Component({
  selector: "app-redeem-pack",
  templateUrl: "./redeem-pack.component.html",
  styleUrls: ["./redeem-pack.component.scss"]
})
export class RedeemPackComponent implements OnInit {
  packs;
  noCredit
  errorPopup = false;
  responseText = '';
  success=false;
  loader = false;
  wallet: any;

  constructor(private location: Location, private gameservice: GameService) {}

  ngOnInit() {
    this.getAvailablePacks();
    this.getPlayerData();
  }

  getAvailablePacks(){
    this.gameservice.getAvailablePacks().subscribe(data=>{
     
      this.packs=data['responseData'];
      
    })
  }

  getPlayerData() {
    this.gameservice.getPlayerData().subscribe(data => {
      this.wallet = data['responseData'].wallet.counters[3];
      
    });
  }

  goBack() {
    this.location.back();
  }

  redeemPack(searchKey){
    this.loader = true;
    this.gameservice.redeemPack(searchKey).subscribe(data=>{

      let response = data;
     

      if (response['responseCode'] == '200') {
        this.errorPopup = false;
        this.success = true;
        this.loader = false;
      } else if (response['responseCode'] == '400') {
        this.success = false;
        this.errorPopup = true;

        if (response['responseData'].errorCode == 'ALREADY_BOUGHT') {
          this.responseText = 'redeem.alreadybought';
        } else if (response['responseData'].errorCode == 'ERROR_GIVIN_DATA') {
          this.responseText = 'redeem.unuseddata';
        } else if (response['responseData'].errorCode == 'INSUFFICIENT_CREDIT') {
          this.responseText = 'redeem.insuficientdata';
        }
        this.loader = false;
      }
     
    })
  }
  close(){
    this.loader = false;
    this.errorPopup=false;
    this.success = false;
  }
}
